import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("sim-card-termination"),
  // No endpoint - the page posts to the sim-cards/terminate endpoints.
  roleView: [ROLE.HARDWARE_UNIT_ADMIN],
  roleAdmin: [ROLE.HARDWARE_UNIT_ADMIN],
  baseRoute: "sim-card-termination",
  singularName: (t) => t("SIM card termination"),
  name: (t) => t("Terminate SIM cards"),
});

export default conf;
